import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';
import './Home.css';
const images = [
    
    '/images/ej95.jpg',
    '/images/benz2.jpg'
];

function EarlyLife() {
    return (
        <div className="container">
            <h1>Early life</h1>

<p>
I was born on the 6th of November, 2004, and grew up as an only child. Ever since I was little, curiosity was part of who I was. Almost every toy, gadget, or electronic device I got would eventually end up disassembled on my desk, just so I could understand how it worked internally.
</p>

<p>
Looking back, that constant need to understand systems and mechanisms was probably one of the first signs that engineering would become a huge part of my life. I was never satisfied with simply using technology — I always wanted to know what was behind it, how it was designed, why it failed, and how it could be improved.
</p>

<p>
That mindset naturally evolved into a passion for problem solving, hands-on work, and creating things from scratch.
</p>

<div style={{ height: '100px' }}></div>

<h1>My life and technology</h1>

<p>
Since a very young age, my passion for computers, electronics, and programming kept growing. I believe a big part of it started with the 
<a href="https://pt.wikipedia.org/wiki/Port%C3%A1til_Magalh%C3%A3es"> Magalhães</a>, a small educational laptop that introduced many kids in Portugal to computers. For me, it became much more than that — it was the beginning of an obsession with technology.
</p>

<p>
As years passed, I started exploring everything I could get my hands on. I spent countless hours learning independently through forums, YouTube videos, experimentation, and trial and error. I was the kind of person who preferred opening devices rather than simply replacing them.
</p>

<p>
Since young, I have always identified strongly with the 
<a href="https://en.wikipedia.org/wiki/Maker_culture"> Maker</a> mindset. My interests ranged from board-level electronics repair, gaming console modding and hacking, custom fabrication projects, and embedded systems, all the way to building custom electric scooters and motorized bicycles.
</p>

<p>
What always attracted me the most was the intersection between hardware and software. I enjoy understanding systems end-to-end — not just programming something, but also understanding the electronics, communications, sensors, mechanical constraints, and real-world limitations behind it.
</p>

<p>
Over time, that curiosity evolved into increasingly complex projects involving automotive electronics, CAN communication, telemetry systems, embedded Linux environments, Raspberry Pis, custom dashboards, and ECU-related development. I enjoy projects where software directly interacts with physical systems, especially when reliability and real-time data matter.
</p>

<p>
Currently, I am studying Computer Engineering at ISEL and working at Critical TechWorks, while also participating in Formula Student, where I have been involved in projects related to electric vehicle systems and engineering development. Being able to work on real-world systems under strict technical requirements pushed me even further as both an engineer and problem solver.
</p>

<div style={{ height: '100px' }}></div>

<h1>2nd biggest passion: Cars</h1>

<p>
My second biggest passion is cars and anything motorized. That passion started very early, largely because of my dad is a huge petrol-head, and also him taking me to classic car shows and introducing me to automotive culture from a young age.
</p>

<p>
Like many enthusiasts, videogames also played a huge role. Games such as Gran Turismo, Grand Theft Auto, Need for Speed, and other racing simulators made me fascinated not only by driving, but also by vehicle mechanics, tuning, and engineering.
</p>

<p>
As I grew older, cars stopped being just a hobby and became another technical passion. I became deeply interested in how engines work, engine management systems, suspension geometry, fabrication, diagnostics, wiring, and performance tuning.
</p>

<p>
Currently, I own a 1989 Mercedes-Benz E300D and a 2000 Honda Civic EJ9. The two cars represent very different worlds, which is exactly what makes them interesting to me.
</p>

<p>
The Mercedes-Benz reflects my appreciation for old-school engineering, mechanical simplicity, durability, and comfort. The OM603 diesel engine, the chassis feel, and the overall character of the car represent an era where vehicles were designed with a very different philosophy.
</p>

<p>
The Honda Civic, on the other hand, represents lightweight engineering, simplicity, tuning culture, and endless modification potential. It became a platform where I could experiment, learn, fabricate, diagnose, and improve things myself - ranging from suspension and intake/exhaust work to electronics and standalone ECU experimentation.
</p>

<p>
What fascinates me most about the automotive world is how multidisciplinary it is. A car combines mechanics, electronics, software, physics, manufacturing, design, and problem solving into a single machine. That is probably why it aligns so naturally with who I am.
</p>
            <div style={{ height: '100px' }}></div>
            <Carousel className="life-carousel">
                {images.map((image, index) => (
                    <Carousel.Item key={index}>
                        <img
                            className="d-block w-100"
                            src={image}
                            alt={`Car ${index + 1}`}
                        />
                    </Carousel.Item>
                ))}
            </Carousel>


        </div>
    );
}

export default EarlyLife;
